<template>
  <div>
    <component :is="mainTag">
      <div>
        <div v-if="currentView == 'list'">
          <v-container>
            <template v-if="loading">
              <div class="text-xs-center" style="padding: 10px 0px">
                <scale-loader
                  :color="$vuetify.theme.primary"
                  height="35px"
                  width="7px"
                ></scale-loader>
              </div>
            </template>
            <template v-else>
              <div class="broadcasts">
                <h2 class="headline mb-3">{{ $t('Add new broadcast') }}</h2>
                <div style="margin-bottom: 15px">
                  <a
                    href="javascript:void(0);"
                    style="text-decoration: none"
                    @click="
                      selected_edit_broadcast = undefined
                      currentView = 'edit'
                      isSaveOnly = false
                    "
                  >
                    <div class="add-broadcast text-xs-center">
                      <em class="fa fa-plus middle" />
                      {{ $t('Add new broadcast') }}
                    </div>
                  </a>
                </div>
                <template v-if="isSupportLineBotGroup">
                  <v-tabs v-model="currentTab" slider-color="primary" class="mb-3">
                    <v-tab href="#general">บรอดแคสต์ทั่วไป</v-tab>
                    <v-tab href="#line-group">บรอดแคสต์ Line Group</v-tab>
                  </v-tabs></template
                >

                <template v-if="['general'].includes(currentTab)">
                  <div style="background: #ffffff 0% 0% no-repeat padding-box; border-radius: 26px">
                    <h2 class="headline mb-3">{{ $t('Draft') }}</h2>
                    <template v-if="draft_broadcasts && draft_broadcasts.length > 0">
                      <div
                        v-for="(broadcast, index) in draft_broadcasts"
                        :key="'draft_broadcast_' + index"
                        class="broadcast mb-3"
                      >
                        <broadcast-item
                          :broadcast="broadcast"
                          :index="index"
                          :draft="true"
                          @editBroadcast="editBroadcast"
                          @copyBroadcast="copyBroadcast"
                          @deleteBroadcast="deleteBroadcast"
                        ></broadcast-item>
                      </div>
                    </template>
                    <template v-else>
                      <p class="no-broadcast text-xs-center">{{ $t('No Sent broadcast') }}</p>
                    </template>
                  </div>
                </template>
                <template v-if="['line-group'].includes(currentTab)">
                  <div style="background: #ffffff 0% 0% no-repeat padding-box; border-radius: 26px">
                    <template
                      v-if="draft_line_group_broadcasts && draft_line_group_broadcasts.length > 0"
                    >
                      <h2 class="headline mb-3">{{ $t('Draft') }}</h2>
                      <div
                        v-for="(broadcast, index) in draft_line_group_broadcasts"
                        :key="'draft_broadcast_' + index"
                        class="broadcast mb-3"
                      >
                        <broadcast-item
                          :broadcast="broadcast"
                          :index="index"
                          :draft="true"
                          @editBroadcast="editBroadcast"
                          @copyBroadcast="copyBroadcast"
                          @deleteBroadcast="deleteBroadcast"
                        ></broadcast-item>
                      </div>
                      <v-pagination
                        v-model="page_line_group_draft"
                        :length="pageLineGroupDraftLength"
                        :total-visible="7"
                        @input="changeLineGroupDraftPage"
                      ></v-pagination>
                    </template>
                  </div>
                </template>
              </div>
            </template>
            <template v-if="['general'].includes(currentTab)">
              <br />
              <div
                v-if="schedule_broadcasts && schedule_broadcasts.length > 0"
                style="background: #ffffff 0% 0% no-repeat padding-box; border-radius: 26px"
              >
                <h2 class="mb-3 headline">{{ $t('schduled_broadcast') }}</h2>
                <div class="broadcasts">
                  <div
                    v-for="(broadcast, index) in schedule_broadcasts"
                    :key="'schedule_broadcast_' + index"
                    class="broadcast mb-3"
                  >
                    <broadcast-item
                      :broadcast="broadcast"
                      :index="index"
                      :draft="true"
                      :is-save-only="true"
                      @editBroadcast="editBroadcast"
                      @copyBroadcast="copyBroadcast"
                      @deleteBroadcast="deleteBroadcast"
                    ></broadcast-item>
                  </div>
                </div>
              </div>
              <br />
              <div
                v-if="sent_broadcasts && sent_broadcasts.length > 0"
                style="background: #ffffff 0% 0% no-repeat padding-box; border-radius: 26px"
              >
                <h3 class="headline mb-3">{{ $t('Broadcasted') }}</h3>

                <template v-if="loading">
                  <div class="text-xs-center" style="padding: 10px 0px">
                    <scale-loader
                      :color="$vuetify.theme.primary"
                      height="35px"
                      width="7px"
                    ></scale-loader>
                  </div>
                </template>
                <template v-else>
                  <div class="broadcasts">
                    <div
                      v-for="(broadcast, index) in sent_broadcasts"
                      :key="'sent_broadcast_' + index"
                      class="broadcast mb-3"
                    >
                      <broadcast-item
                        :broadcast="broadcast"
                        :index="index"
                        :draft="false"
                        @editBroadcast="editBroadcast"
                        @copyBroadcast="copyBroadcast"
                        @viewBroadcast="viewBroadcast"
                        @onShowBroadcastHistory="handleShowBroadcastHistory"
                      ></broadcast-item>
                    </div>
                  </div>
                  <v-pagination
                    v-model="page"
                    :length="pagelength"
                    :total-visible="7"
                    @input="changepage"
                  ></v-pagination>
                  <v-progress-linear
                    v-if="pageloading"
                    height="2px"
                    indeterminate
                    color="primary"
                  ></v-progress-linear>
                </template>
              </div>
            </template>
            <template v-if="['line-group'].includes(currentTab)">
              <br />
              <div
                v-if="schedule_line_group_broadcasts && schedule_line_group_broadcasts.length > 0"
                style="background: #ffffff 0% 0% no-repeat padding-box; border-radius: 26px"
              >
                <h2 class="mb-3 headline">{{ $t('schduled_broadcast') }}</h2>
                <div class="broadcasts">
                  <div
                    v-for="(broadcast, index) in schedule_line_group_broadcasts"
                    :key="'schedule_broadcast_' + index"
                    class="broadcast mb-3"
                  >
                    <broadcast-item
                      :broadcast="broadcast"
                      :index="index"
                      :draft="true"
                      :is-save-only="true"
                      @editBroadcast="editBroadcast"
                      @copyBroadcast="copyBroadcast"
                      @deleteBroadcast="deleteBroadcast"
                    ></broadcast-item>
                  </div>
                </div>
              </div>
              <br />
              <div
                v-if="sent_line_group_broadcasts && sent_line_group_broadcasts.length > 0"
                style="background: #ffffff 0% 0% no-repeat padding-box; border-radius: 26px"
              >
                <h3 class="headline mb-3">{{ $t('Broadcasted') }}</h3>

                <template v-if="loading">
                  <div class="text-xs-center" style="padding: 10px 0px">
                    <scale-loader
                      :color="$vuetify.theme.primary"
                      height="35px"
                      width="7px"
                    ></scale-loader>
                  </div>
                </template>
                <template v-else>
                  <div class="broadcasts">
                    <div
                      v-for="(broadcast, index) in sent_line_group_broadcasts"
                      :key="'sent_broadcast_' + index"
                      class="broadcast mb-3"
                    >
                      <broadcast-item
                        :broadcast="broadcast"
                        :index="index"
                        :draft="false"
                        @editBroadcast="editBroadcast"
                        @copyBroadcast="copyBroadcast"
                        @viewBroadcast="viewBroadcast"
                        @onShowBroadcastHistory="handleShowBroadcastHistory"
                      ></broadcast-item>
                    </div>
                  </div>
                  <v-pagination
                    v-model="page_line_group"
                    :length="pageLineGroupSentLength"
                    :total-visible="7"
                    @input="changeLineGroupSentPage"
                  ></v-pagination>
                </template>
              </div>
            </template>
          </v-container>
          <div class="mt-5 mb-5"></div>
        </div>
        <div v-if="currentView == 'edit'">
          <template v-if="currentView == 'edit'">
            <broadcast-manage
              :value="selected_edit_broadcast"
              :is-save-only="isSaveOnly"
              :is-line-group="['line-group'].includes(currentTab)"
              @onClose="onClose"
              @onSave="onSave"
            ></broadcast-manage>
          </template>
        </div>
        <div v-if="currentView == 'view'">
          <template v-if="selected_view_broadcast">
            <broadcast-view :value="selected_view_broadcast" @onClose="onClose"></broadcast-view>
          </template>
        </div>
      </div>
    </component>

    <DialogBroadcastHistoryVue
      :value="showDialogBroadcastHistory"
      :broadcast="currentBroadcast"
      :type="currentBroadcastLogType"
      @onClose="handleDialogBroadcastHistory"
    />
  </div>
</template>

<script>
import BroadcastManage from './BroadcastManage'
import BroadcastView from './BroadcastView'
import api from '@/api'
import { mapGetters } from 'vuex'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import moment from 'moment'
import BroadcastItem from './BroadcastItem.vue'
import gpfBuddyApi from '@/api/gpf-buddy'
import lamyApi from '@/api/lamy'
import { PAGE } from '@/constants/page.js'
import { LINE_BOT_GROUP_SUPPORT } from '@/constants/line-bot-group.js'
import DialogBroadcastHistoryVue from '../template/Aira/Broadcast/DialogBroadcastHistory.vue'
import lineBotGroupApi from '@/api/line-bot-group'
import dayjs from 'dayjs'
export default {
  name: 'BroadcastVue',
  components: {
    BroadcastManage,
    BroadcastView,
    ScaleLoader,
    BroadcastItem,
    DialogBroadcastHistoryVue
  },
  props: {
    child: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      copy_name: '',
      sent_name: '',
      isSave: false,
      pageloading: false,
      isCopy: false,
      currentView: 'list',
      isFail: false,
      draft_broadcasts: [],
      sent_broadcasts: [],
      schedule_broadcasts: [],
      selected_edit_broadcast: undefined,
      selected_view_broadcast: undefined,
      loading: true,
      page: 1,
      pagetmp: 1,
      pagetotal: 0,
      offset: 1,
      limit: 10,
      isSaveOnly: false,
      currentBroadcast: undefined,
      showDialogBroadcastHistory: false,
      currentBroadcastLogType: undefined,
      // TODO: Line Group
      currentTab: 'general',
      draft_line_group_broadcasts: [],
      sent_line_group_broadcasts: [],
      schedule_line_group_broadcasts: [],
      page_line_group_draft: 1,
      page_line_group_draft_tmp: 1,
      page_line_group_draft_total: 0,
      page_line_group: 1,
      page_line_group_tmp: 1,
      page_line_group_total: 0
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pagelength() {
      if (this.pagetotal) {
        return Math.ceil(this.pagetotal / 10)
      } else {
        return 1
      }
    },
    pageLineGroupSentLength() {
      if (this.page_line_group_total) {
        return Math.ceil(this.page_line_group_total / 10)
      } else {
        return 1
      }
    },
    pageLineGroupDraftLength() {
      if (this.page_line_group_draft_total) {
        return Math.ceil(this.page_line_group_draft_total / 10)
      } else {
        return 1
      }
    },
    isGpfBuddy() {
      return PAGE.GPF_BUDDY.includes(this.selectedBot.pageid)
    },
    isLamy() {
      return [...this.$store.state.lamyPage].includes(this.selectedBot.pageid)
    },
    mainTag() {
      return this.child ? 'div' : 'main-layout'
    },
    isSupportLineBotGroup() {
      return LINE_BOT_GROUP_SUPPORT.includes(this.selectedBot.pageid)
    }
  },
  watch: {
    currentTab() {
      const vm = this
      vm.page = 1
      vm.pagetmp = 1
      if (['line-group'].includes(vm.currentTab)) {
        vm.getBroadcastLineGroup(function () {
          vm.loading = false
        }, 'draft')
        vm.getBroadcastLineGroup(function () {
          vm.loading = false
        }, 'sent')
      }
    }
  },
  mounted: function () {
    const vm = this

    if (vm.$store.state.shoptheme.includes(vm.selectedBot.theme)) {
      vm.$store.dispatch('loadCategory').then(function () {
        vm.$store.dispatch('loadProducts')
      })
      vm.$store.dispatch('loadCharges')
    }
    vm.$store.dispatch('loadSetting')
    vm.loading = true
    vm.getBroadcast(function () {
      vm.loading = false
    }, 'draft')
    vm.getBroadcast(function () {
      vm.loading = false
    }, 'broadcasted')
    vm.$store.dispatch('loadStatus')

    if (this.selectedBot.theme == 'universalutilities') {
      vm.$store.dispatch('loadLinePushMessageCount', {
        dateform: moment().startOf('month').format('YYYY-MM-DD'),
        dateto: moment().endOf('month').format('YYYY-MM-DD')
      })
    }

    if (vm.isGpfBuddy) {
      vm.getGpfBuddyMasterData()
    }

    if (vm.isLamy) {
      vm.getLamyProductMasterData()
    }
  },
  methods: {
    handleDialogBroadcastHistory() {
      this.showDialogBroadcastHistory = false
      this.currentBroadcast = undefined
      this.currentBroadcastLogType = undefined
    },
    handleShowBroadcastHistory({ type, broadcast }) {
      if (this.selectedBot.theme != 'aira') {
        return false
      }
      this.currentBroadcast = broadcast
      this.currentBroadcastLogType = type
      this.showDialogBroadcastHistory = true
    },
    changepage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        this.getBroadcast(function () {
          vm.loading = false
        }, 'broadcasted')
      }
    },
    changeLineGroupSentPage(val) {
      const vm = this
      if (vm.page_line_group_tmp !== val) {
        vm.page_line_group_tmp = val
        vm.getBroadcastLineGroup(function () {
          vm.loading = false
        }, 'sent')
      }
    },
    changeLineGroupDraftPage(val) {
      var vm = this
      if (this.page_line_group_draft_tmp == val) {
        //dont do shit
      } else {
        this.page_line_group_draft_tmp = val
        this.getBroadcastLineGroup(function () {
          vm.loading = false
        }, 'draft')
      }
    },
    onClose: function () {
      var vm = this
      vm.currentView = 'list'
      vm.loading = true
      if (['line-group'].includes(vm.currentTab)) {
        vm.getBroadcastLineGroup(function () {
          vm.loading = false
        }, 'draft')
        vm.getBroadcastLineGroup(function () {
          vm.loading = false
        }, 'sent')
      } else {
        vm.getBroadcast(function () {
          vm.loading = false
        }, 'draft')
        vm.getBroadcast(function () {
          vm.loading = false
        }, 'broadcasted')
      }
    },
    getBroadcast: function (callback, status) {
      var vm = this
      vm.offset = vm.page * 10 - 10
      if (vm.page != 1) {
        vm.offset + 1
      }
      vm.pageloading = true
      var data = {}
      if (status == 'broadcasted') {
        data = { pageid: vm.selectedBot.pageid, limit: vm.limit, offset: vm.offset, status }
      } else {
        data = { pageid: vm.selectedBot.pageid, status }
      }
      api.getBroadcast(data, function (error, response) {
        if (error) {
          console.error(error)
          callback()
          return
        }
        vm.pageloading = false

        if (response.data) {
          if (status == 'broadcasted') {
            vm.pagetotal = parseInt(response.total)
            vm.sent_broadcasts.length = 0
          }
          if (status == 'draft') {
            vm.draft_broadcasts.length = 0
            vm.schedule_broadcasts.length = 0
          }
          if (response.data) {
            response.data.forEach((broadcast) => {
              if (status === 'draft' && broadcast.status == 'draft') {
                vm.draft_broadcasts.push(broadcast)
              } else if (broadcast.isschedule && status == 'draft' && broadcast.status == 'sent') {
                vm.schedule_broadcasts.push(broadcast)
              } else {
                vm.sent_broadcasts.push(broadcast)
              }
            })
          }
        }
        callback()
      })
    },
    getBroadcastLineGroup: function (callback, status) {
      const vm = this
      const pageType = ['draft'].includes(status) ? vm.page_line_group_draft : vm.page_line_group
      vm.offset = pageType * 10 - 10
      if (pageType != 1) {
        vm.offset + 1
      }
      vm.pageloading = true
      lineBotGroupApi
        .getListBroadcast({
          pageId: vm.selectedBot.pageid,
          status: ['draft'].includes(status) ? 'draft' : 'sent',
          limit: vm.limit,
          offset: vm.offset
        })
        .then((response) => {
          vm.pageloading = false

          if (response.data) {
            const { total, data } = response.data
            if (status == 'sent') {
              vm.page_line_group_total = parseInt(total)
              vm.sent_line_group_broadcasts.length = 0
            }
            if (status == 'draft') {
              vm.page_line_group_draft_total = parseInt(total)
              vm.draft_line_group_broadcasts.length = 0
              vm.schedule_line_group_broadcasts.length = 0
            }
            if (data) {
              data.map((broadcast) => {
                if (status === 'draft' && broadcast.status == 'draft') {
                  vm.draft_line_group_broadcasts.push(vm.resolvedMapperBroadcast(broadcast))
                } else if (
                  !!broadcast.schedule_timestamp &&
                  broadcast.status == 'sent' &&
                  dayjs().isBefore(dayjs(broadcast.schedule_timestamp))
                ) {
                  vm.schedule_line_group_broadcasts.push(vm.resolvedMapperBroadcast(broadcast))
                } else {
                  vm.sent_line_group_broadcasts.push(vm.resolvedMapperBroadcast(broadcast))
                }
              })
            }
          }
          callback()
        })
        .catch((error) => {
          console.error(error)
          callback()
        })
        .finally(() => {
          vm.pageloading = false
        })
    },
    editBroadcast: function (broadcasts, isSaveOnly) {
      const vm = this
      vm.selected_edit_broadcast = broadcasts
      vm.currentView = 'edit'
      vm.isSaveOnly = isSaveOnly
    },
    viewBroadcast: function (index) {
      var vm = this
      this.selected_view_broadcast = this.sent_broadcasts[index]
      vm.$nextTick(function () {
        vm.currentView = 'view'
      })
    },
    deleteBroadcast: function (broadcastid, broadcastname, isSaveOnly) {
      var vm = this
      vm.$swal
        .fire({
          title: vm.$t('Do you want to delete {name}?', {
            // eslint-disable-next-line no-useless-escape
            name: broadcastname.replace(/\<|\>/g, '')
          }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            if (['line-group'].includes(vm.currentTab)) {
              lineBotGroupApi
                .deleteBroadcastById({
                  pageId: vm.selectedBot.pageid,
                  broadcastId: +broadcastid
                })
                .then(() => {
                  if (isSaveOnly) {
                    vm.schedule_line_group_broadcasts.map((broadcast, index) => {
                      if (broadcast.id == broadcastid) {
                        vm.schedule_line_group_broadcasts.splice(index, 1)
                        return false
                      }
                    })
                  } else {
                    vm.draft_line_group_broadcasts.map((broadcast, index) => {
                      if (broadcast.id == broadcastid) {
                        vm.draft_line_group_broadcasts.splice(index, 1)
                        return false
                      }
                    })
                  }
                })
                .catch((error) => {
                  console.error(error)
                })
            } else {
              api.deleteBroadcast(
                { pageid: vm.selectedBot.pageid, broadcastid: broadcastid },
                function (error) {
                  if (error) {
                    console.error(error)
                    // vm.loading = true
                    return
                  }

                  if (isSaveOnly) {
                    vm.schedule_broadcasts.map((broadcast, index) => {
                      if (broadcast.id == broadcastid) {
                        vm.schedule_broadcasts.splice(index, 1)
                        return false
                      }
                    })
                  } else {
                    vm.draft_broadcasts.map((broadcast, index) => {
                      if (broadcast.id == broadcastid) {
                        vm.draft_broadcasts.splice(index, 1)
                        return false
                      }
                    })
                  }
                }
              )
            }
          }
        })
    },
    onSave: function (payload) {
      var vm = this
      vm.saveBroadcast(payload.data, function (status, id) {
        payload.onSave(status, id)
      })
    },
    copyBroadcast: function (payload, type) {
      var vm = this
      var data = null

      var broadcast = null
      if (payload == null) return false
      if (type === 'draft') {
        if (['line-group'].includes(vm.currentTab)) {
          broadcast = vm.draft_line_group_broadcasts.find((el) => {
            return el.id == payload.id
          })
        } else {
          broadcast = vm.draft_broadcasts.find((el) => {
            return el.id == payload.id
          })
        }
        if (broadcast) data = Object.assign({}, broadcast)
      } else if (type === 'sent') {
        if (['line-group'].includes(vm.currentTab)) {
          broadcast = vm.sent_line_group_broadcasts.find((el) => {
            return el.id == payload.id
          })
        } else {
          broadcast = vm.sent_broadcasts.find((el) => {
            return el.id == payload.id
          })
        }

        if (broadcast) data = Object.assign({}, broadcast)
      }
      if (data == null) return false
      vm.$swal
        .fire({
          // eslint-disable-next-line no-useless-escape
          title: vm.$t('Do you want to copy {name}?', { name: data.name.replace(/\<|\>/g, '') }),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: vm.$t('Confirm'),
          cancelButtonText: vm.$t('cancel'),
          reverseButtons: true
        })
        .then((result) => {
          if (result.value) {
            data.id = null
            data.name += ' copy'
            ;(data.sendflag = false),
              (data.page_access_token = vm.selectedBot.page_access_token),
              (vm.copy_name = data.name)
            if (['line-group'].includes(vm.currentTab)) {
              const payload = {
                broadcast_id: null,
                name: data.name,
                group_ids: null,
                broadcast_group_tags: data.update_tags ? data.update_tags : null,
                broadcast_group_status: data.update_status ? data.update_status : null,
                status: data.sendflag ? 'sent' : 'draft',
                schedule_timestamp: !data.scheduletime ? null : data.scheduletime,
                messages: JSON.parse(data.m_val)[0],
                quick_reply: data.m_quick_reply,
                notify: data.notify
              }
              vm.saveBroadcast(payload, function (status, id) {
                if (status) {
                  data.id = id
                  vm.draft_line_group_broadcasts.unshift(data)
                  vm.$swal.fire({
                    title: vm.$t('Broadcast {copy_name} copy', {
                      // eslint-disable-next-line no-useless-escape
                      copy_name: data.name.replace(/\<|\>/g, '')
                    }),
                    type: 'success',
                    confirmButtonText: vm.$t('Confirm'),
                    cancelButtonText: vm.$t('cancel'),
                    reverseButtons: true
                  })
                }
              })
            } else {
              vm.saveBroadcast(data, function (status, id) {
                if (status) {
                  data.id = id
                  vm.draft_broadcasts.unshift(data)
                  vm.$swal.fire({
                    title: vm.$t('Broadcast {copy_name} copy', {
                      // eslint-disable-next-line no-useless-escape
                      copy_name: data.name.replace(/\<|\>/g, '')
                    }),
                    type: 'success',
                    confirmButtonText: vm.$t('Confirm'),
                    cancelButtonText: vm.$t('cancel'),
                    reverseButtons: true
                  })
                }
              })
            }
          }
        })
    },
    saveBroadcast: function (data, callback) {
      try {
        if (!data.m_type) {
          lineBotGroupApi
            .postBroadcast({
              data,
              pageId: this.selectedBot.pageid
            })
            .then((response) => {
              let id = null
              if (response.broadcastid) {
                id = response.broadcastid
              }
              callback(true, id)
            })
            .catch((error) => {
              console.error(error)
              callback(false, null)
            })
        } else {
          api.updateBroadcast(data, function (error, response) {
            if (error) {
              console.error(error)
              callback(false, null)
              return
            }
            let id = null
            if (response.broadcastid) {
              id = response.broadcastid
            }
            callback(true, id)
          })
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getGpfBuddyMasterData() {
      const vm = this
      try {
        const data = {
          pageId: vm.selectedBot.pageid
        }
        const response = await gpfBuddyApi.getCompanyMasterData({ config: data })
        if (response && response.status === 200) {
          vm.$store.state.gpfBuddyMasterData = response.data.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async getLamyProductMasterData() {
      const vm = this
      try {
        const data = {
          pageId: vm.selectedBot.pageid
        }
        const response = await lamyApi.getFilterProductMasterData({ config: data })
        if (response && response.status === 200) {
          vm.$store.state.lamyFilterProductMasterData = response.data.filter
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    resolvedMapperBroadcast(broadcast) {
      return {
        admingroupid: null,
        approval_reason: null,
        approved_at: null,
        approved_by: null,
        createdby: broadcast.created_by,
        createdtime: broadcast.created_at,
        groupidlist: '',
        id: broadcast.id,
        isschedule: !!broadcast.schedule_timestamp,
        m_condition: '',
        m_quick_reply: broadcast.quick_reply,
        m_type: 'json',
        m_val: JSON.stringify([broadcast.messages]),
        name: broadcast.name,
        no_reach: broadcast.no_reach,
        no_read: '0',
        no_unreach: '0',
        notify: broadcast.notify,
        pageid: broadcast.page_id,
        pushtype: '',
        scheduletime: broadcast.schedule_timestamp,
        securityflag: '1',
        sendtype: 'promotion',
        senttime: broadcast.sent_timestamp,
        status: broadcast.status,
        total: broadcast.total,
        update_user_status: broadcast.broadcast_group_status,
        update_user_tags: broadcast.broadcast_group_tags,
        useridlist: ''
      }
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/broadcast/Broadcast.vue